var exports = {
  "q": "AuthLoginEmailPasswordForm.module__footer___X05jNG",
  "h": "AuthLoginEmailPasswordForm.module__status___X05jNG",
};

module.exports = exports;
